<div class="container-fluid d-flex justify-content-center flex-wrap bg-purple" >
    <div class="col-12 p-3 text-white text-center">
        <h1>
            Swap Bitssa
        </h1>
        <h5 style="font-weight: 100;">
            Buy stable coins from fiat
        </h5>
    </div>
    <div class="col-12 col-md-4 p-4 my-3 bg-white rounded-more">
        <div class="input-group">
            <label for="sourceAmount" class="form-label w-100 h5">Source amount</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control rounded bg-light border-0 p-4" placeholder="Source amount" aria-label="Source amount" aria-describedby="basic-addon2" [(ngModel)]="sourceAmount" (input)="changeDestinationAmount()">
                <button type="button" class="btn text-dark bg-transparent dropdown-toggle rounded text-left position-absolute h-100 border border-dark" style="right:0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img [src]="titleUrl"  class="mx-2" style="width:16px !important">
                    {{title}} &nbsp;&nbsp;
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngFor="let source of sources" (click)="selectSource(source)">
                        <img [src]="source.icon?.url"  [alt]="source.name" class="mx-2" style="width:16px !important">
                        {{source.Name}}
                    </a>
                </div>
            </div>
            
        </div>
        <div class="d-flex">
            <div class="col-1 d-flex align-items-stretch justify-content-center">
                <div class="d-flex flex-column justify-content-around" style="background-image:url('../../assets/images/homepage_bg.png');background-repeat: no-repeat;background-position: center;">
                    <img src="../../assets/images/homepage_calc_circle.png" alt="">
                    <img src="../../assets/images/homepage_calc_circle.png" alt="">
                </div>
            </div>
            <div class="col-10 d-flex flex-column">
                <div class="pb-3 d-flex justify-content-between px-2 ml-2">
                    <span>
                        <span class="text-secondary">Fees charged</span> <br />
                        {{fees}} <span class="text-primary">{{selectedSource?.Name}}</span>
                    </span>
                </div>
                <div class="pb-3 d-flex justify-content-between px-2 ml-2">
                    <span>
                        <span class="text-secondary">Conversion rate</span> <br />
                        1 <span class="text-primary">{{selectedSource?.Name}}</span> =  {{conversionRate}} <span class="text-primary">{{selectedDestination?.name}}</span>
                    </span>
                </div>
                
            </div>
            <!-- <div class="col-12 col-md-4 d-flex align-items-center flex-wrap justify-content-center">
                <h1 class="text-center d-flex flex-wrap justify-content-left text-white px-5">
                    <span class="py-1 h1 w-100 text-left">Stable coins to Fiat.</span>
                    <span class="py-1 h2 w-100 text-left" style="font-weight: 100;">Made Easy!</span>
                    <button class="btn btn-outline-light px-5 py-1" data-toggle="modal" data-target="#loginRegisterModal">
                        Go to App!
                    </button>
                </h1>
            </div> -->
        </div>
        <div class="input-group mb-3">
            <label for="convertedAmount" class="form-label w-100 h5">Destination amount</label>
            <div class="input-group mb-3 position-relative">
                <input type="number" class="form-control rounded bg-light border-0 p-4" placeholder="Destination amount" aria-label="Destination amount" aria-describedby="basic-addon2" [(ngModel)]="convertedAmount" readonly>

                <button type="button" class="btn text-dark bg-transparent dropdown-toggle rounded text-left position-absolute h-100 border border-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="right:0">
                    <img [src]="title1Url"  class="mx-2" style="width:16px !important">
                    {{title1}} &nbsp;&nbsp;
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" *ngFor="let destination of destinations" (click)="selectDestination(destination)">
                        <img [src]="destination.image?.url"  [alt]="destination.name" class="mx-2" style="width:16px !important">
                        {{destination.name}}
                    </a>
                </div>
            </div>    
        </div>
        <div class="input-group mb-3">
            <button class="btn btn-outline-primary w-100" [disabled]="checkPaybutton()" (click)="postTransaction()">Pay {{totalAmountToBePaid}} {{selectedSource?.Name}}</button>
        </div>
    </div>
    <form
      ngNoForm
      [action]="psiUrl"
      method="post"
      *ngIf="true"
      class="d-none"
    >
      <input type="TEXT" name="StoreKey" [value]="storeKeyPsi"/>StoreKey<br />
      <input type="TEXT" name="SubTotal" [value]="totalAmountToBePaid" />SubTotal<br />
      <input type="TEXT" name="Email" [value]="userEmail" />Email<br />
      <input type="TEXT" name="PaymentType" value="CC" />PaymentType<br />
      <input type="TEXT" name="CardAction" value="0" />CardAction<br />
      <input type="TEXT" name="CustomerRefNo" [value]="transactionId" />CardAction<br />
      <input id="psiFormButton" type="SUBMIT" value="PAY"  />
    </form>
</div>